import React, { useEffect, useState, useCallback } from "react";
import { message } from "antd";

import {
  PlusCircle,
  Edit,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import AddEnvelope from "./editenvelope";
import { deleteMarketingFile } from "../../core/api/marketing";
import { getIndependentEnvelopeStocks } from "../../core/api/products";
import { Link } from "react-router-dom";
import Table from "../../core/pagination/datatable";
import { useSelector } from "react-redux";

const EnvelopeList = () => {
  const [envelopes, setEnvelopes] = useState([]);
  const [isAddEnvelopeVisible, setIsAddEnvelopeVisible] = useState(false);
  const [clientId, setClientId] = useState(null);
  const [currentEnvelopeId, setCurrentEnvelopeId] = useState(null);
  const [sidebarWidth, setSidebarWidth] = useState(0);
  const MySwal = withReactContent(Swal);
  const selectedClients = useSelector((state) => state.selectedClients);
  const [loading, setLoading] = useState(false);
  const fetchEnvelopes = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getIndependentEnvelopeStocks(selectedClients);
      setEnvelopes(response.data);
    } catch (error) {
      message.error("Failed to fetch envelopes.");
    } finally {
      setLoading(false);
    }
  }, [selectedClients, setLoading, setEnvelopes]);

  useEffect(() => {
    fetchEnvelopes();
  }, [selectedClients, fetchEnvelopes]);

  const handleDelete = async (envelopeId) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteMarketingFile(envelopeId);
          message.success("Envelope deleted successfully.");
          fetchEnvelopes();
        } catch (error) {
          message.error("Failed to delete envelope.");
        }
      }
    });
  };

  const handleAddEnvelopeClose = () => {
    setIsAddEnvelopeVisible(false);
    fetchEnvelopes();
    setCurrentEnvelopeId(null);
  };

  const columns = [
    {
      title: "File Type",
      dataIndex: "file_type",
      key: "fileType",
      width: 150,
      render: (text) => text || "N/A",
    },
    {
      title: "File Name",
      dataIndex: "file_name",
      key: "fileName",
      width: 150,
      render: (text) => text || "N/A",
    },
    {
      title: "File Code",
      dataIndex: "file_code",
      key: "fileCode",
      width: 100,
    },
    {
      title: "Pages",
      dataIndex: "pages",
      key: "pages",
      width: 90,
    },
    {
      title: "Length",
      dataIndex: "length",
      key: "length",
      width: 90,
    },
    {
      title: "Width",
      dataIndex: "width",
      key: "width",
      width: 90,
    },
    {
      title: "Printer",
      dataIndex: "printer",
      key: "printer",
      width: 100,
      render: (text) => text || "N/A",
    },
    {
      title: "Qty Printed",
      dataIndex: "qty_printed",
      key: "qtyPrinted",
      width: 90,
      render: (text) => text || 0,
    },
    {
      title: "Unit Price",
      dataIndex: "unit_price",
      key: "unitPrice",
      width: 90,
      render: (text) => (text !== null ? text.toFixed(3) : "0.000"),
    },
    {
      title: "Total Qty Used",
      dataIndex: "total_quantity_used",
      key: "totalQtyUsed",
      width: 90,
      render: (text) => text || 0,
    },
    {
      title: "File",
      dataIndex: "file",
      key: "file",
      width: 150,
      render: (text) =>
        text ? (
          <a href={text} target="_blank" rel="noopener noreferrer">
            View File
          </a>
        ) : (
          "No File"
        ),
    },
    {
      title: "Action",
      key: "action",
      width: 100,
      fixed: "right",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              onClick={() => {
                setIsAddEnvelopeVisible(true);
                setCurrentEnvelopeId(record.file_id);
                setClientId(record.client_id);
              }}
              title="Edit"
            >
              <Edit className="feather-edit" />
            </Link>
            <Link
              className="confirm-text p-2"
              to="#"
              onClick={() => handleDelete(record.file_id)} // Updated to use file_id
              title="Delete"
            >
              <Trash2 className="feather-trash-2" />
            </Link>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div
        className="content"
        style={{
          width: isAddEnvelopeVisible
            ? `calc(100% - ${sidebarWidth}px)`
            : "100%",
          transition: "width 0.3s ease-in-out",
        }}
      >
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Envelopes List</h4>
              <h6>Manage your envelopes</h6>
            </div>
          </div>
          <div className="page-btn">
            <Link
              className="btn btn-added"
              onClick={() => {
                if (
                  selectedClients.length == 1 &&
                  selectedClients[0] !== "all"
                ) {
                  setClientId(selectedClients[0]);
                  setIsAddEnvelopeVisible(true);
                } else {
                  message.warning("Please select only one client.");
                }
              }}
            >
              <PlusCircle className="me-2 iconsize" />
              Add Envelope
            </Link>
          </div>
        </div>

        <Table
          dataSource={envelopes}
          columns={columns}
          rowKey={(record) => record.id}
          loading={loading}
        />
      </div>
      <AddEnvelope
        isVisible={isAddEnvelopeVisible}
        onClose={handleAddEnvelopeClose}
        onResize={setSidebarWidth}
        envelopeId={currentEnvelopeId}
        clientId={clientId}
      />
    </div>
  );
};

export default EnvelopeList;
